/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useState} from "react";
import {useEffectPromise} from "../../../Hooks/EffectHooks";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";

export const ServiceDrivenFieldViewer = (service) => {
	const loadModel = async (value) => {
		try {
			const data = await service.FindById(value);
			return data?.result ?? null;
		} catch (e) {
			console.log('loadModel failed for value:', value, e);
		}
		return null;
	}

	return (props) => {

		const {
			titlePrefix = null,
			titleSuffix = null,
			nullDisplayLabel = 'N/A',
			Value: value,
			loadingLabel = "Loading...",
			className = "sb-autocomplete-item",
		} = props;

		const [selectedModel, setSelectedModel] = useState(undefined);
		const loaded = usePrimeCache(service);

		useEffectPromise(
			async () => loadModel(value),
			(result) => {
				setSelectedModel(result);
			},
			[loaded, value]
		);

		if (!loaded || selectedModel === undefined) {
			return loadingLabel;
		}

		if (!selectedModel) {
			return nullDisplayLabel;
		}

		let icon = service.GetIcon(selectedModel);
		let title = service.GetTitle(selectedModel);
		let subtitle = service.GetSubtitle(selectedModel);

		return <div className={className}>
			{icon}
			<div>
				<div className="title">{titlePrefix}{title}{titleSuffix}</div>
				<div className="subtitle">{subtitle}</div>
			</div>
		</div>
	}
}
